export function shouldSubmitReply(input: {
	cannedResponsesOpen: boolean;
	isComposing: boolean;
	key: string;
	shiftKey: boolean;
}): boolean {
	return (
		input.key === 'Enter' && !input.shiftKey && !input.isComposing && !input.cannedResponsesOpen
	);
}

export type ReplyDeliveryMode = 'reply' | 'whisper';

export interface ReplyDraftContext {
	conversationId: string;
	mode: ReplyDeliveryMode;
}

export function replyDraftCanSend(
	draft: ReplyDraftContext | undefined,
	conversationId: string | undefined,
	mode: ReplyDeliveryMode | undefined,
): boolean {
	return Boolean(
		draft &&
		conversationId &&
		mode &&
		draft.conversationId === conversationId &&
		draft.mode === mode,
	);
}

export const MAXIMUM_COPILOT_EDIT_DISTANCE = 2_048;

export function copilotEditDistance(original: string, edited: string): number {
	if (original === edited) return 0;
	let start = 0;
	while (start < original.length && start < edited.length && original[start] === edited[start]) {
		start += 1;
	}
	let originalEnd = original.length;
	let editedEnd = edited.length;
	while (
		originalEnd > start &&
		editedEnd > start &&
		original[originalEnd - 1] === edited[editedEnd - 1]
	) {
		originalEnd -= 1;
		editedEnd -= 1;
	}
	const left = original.slice(start, originalEnd);
	const right = edited.slice(start, editedEnd);
	if (!left.length || !right.length) {
		return Math.min(MAXIMUM_COPILOT_EDIT_DISTANCE, Math.max(left.length, right.length));
	}
	if (
		left.length > MAXIMUM_COPILOT_EDIT_DISTANCE ||
		right.length > MAXIMUM_COPILOT_EDIT_DISTANCE
	) {
		return MAXIMUM_COPILOT_EDIT_DISTANCE;
	}

	let previous = Array.from({ length: right.length + 1 }, (_, index) => index);
	for (let leftIndex = 1; leftIndex <= left.length; leftIndex += 1) {
		const current = [leftIndex];
		for (let rightIndex = 1; rightIndex <= right.length; rightIndex += 1) {
			current[rightIndex] = Math.min(
				current[rightIndex - 1]! + 1,
				previous[rightIndex]! + 1,
				previous[rightIndex - 1]! + (left[leftIndex - 1] === right[rightIndex - 1] ? 0 : 1),
			);
		}
		previous = current;
	}
	return Math.min(MAXIMUM_COPILOT_EDIT_DISTANCE, previous[right.length]!);
}
